<template>
  <v-container class="main-container responsive-height">
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-0 rounded-0 faq-card" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-card-title>
            <v-icon class="mr-3" color="greenMain">mdi mdi-chat-outline</v-icon>
            Frequently Asked Questions
          </v-card-title>
          <v-expansion-panels flat>
            <v-expansion-panel v-for="(item, index) in faqs" :key="item.id">
              <v-expansion-panel-header :color="$vuetify.theme.dark ? '#1A2A3E' : '#F1F7FB'">
                <span class="numbers">{{ index + 1 }}</span>{{ item.question }}
              </v-expansion-panel-header>
              <v-expansion-panel-content :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                <p>{{ item.answer }}</p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { FAQS__ACTIONS } from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
  name: "faqView",
  computed: {
    ...mapState("faqs", ["faqs"]),
  },
  methods: {
    ...mapActions("faqs", [FAQS__ACTIONS.FAQS]),
  },
  async mounted() {
    try {
      await this[FAQS__ACTIONS.FAQS]();
      console.log("faqs", this.faqs);
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
